import { useAbTestsStore, type AbTestResult } from '@/store/ab_tests'
import useABTestV2 from '@/utils/abtest/useABTestV2'

type AbTestConfig = {
  testName: string
  bPatternRatio?: number
  bPatternRange?: [number, number]
  enable: boolean
}

export function useAbTest() {
  const store = useAbTestsStore()

  const initializeAll = (registry: AbTestConfig[]) => {
    registry.forEach(config => {
      const result: AbTestResult | null = useABTestV2(config)
      store.results[config.testName] = result
    })
  }

  const getResult = (testName: string) => store.getResultByName(testName)
  const getGroup = (testName: string) => store.getGroupByName(testName)
  const isActive = (testName: string) => computed(() => getGroup(testName).value !== 'disabled')

  return {
    initializeAll,
    getResult,
    getGroup,
    isActive
  }
}
